/**
 * The ONE name and the ONE explanation for a service's labor section.
 *
 * Both places a service is configured — the pricebook form and the estimate's
 * service line — import these rather than writing their own, because two names
 * for one idea is the drift this whole change exists to remove. The fields
 * themselves are `LaborLinesEditor`, shared with the dynamic pricing editor so
 * the rows cannot diverge either.
 *
 * Cost only. On a FLAT service the price is the number the operator typed and
 * nothing in this section moves it; the hours move gross margin, exactly the
 * way a material's cost does. A DYNAMIC service states its time where that time
 * earns money (its labor lines) and does NOT render this section — one hours
 * concept per mode, or the operator is left guessing which figure the customer
 * is paying for.
 *
 * See SPEC-line-item-model, "Flat vs Dynamic".
 */

export const SERVICE_LABOR_SECTION_TITLE = 'Labor used by this service';

export const SERVICE_LABOR_SECTION_BLURB =
  'Cost only, exactly like the parts this service uses. Hours here change what ' +
  'the job costs us and the gross margin — the price stays exactly as you set it.';
